import styles from './specificationsTab.module.css';
import { formateDate } from '../../../../Website/utils/utils';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import DeliveryAddressPopup from './SelectAddress';
import { toast } from 'react-toastify';
import api from '../../../../Website/utils/api';
import { computeGstTotals, formatINR } from '../../../../Website/utils/gstTotals';


const EnquiryDeets = ({ data, enquiryId, from }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const [selectedProducts, setSelectedProductsState] = useState([]);
    const [open, setOpen] = useState(false);
    const [selectedAddress, setSelectedAddress] = useState(null);

    const handleCheckboxChange = (item) => {
        setSelectedProductsState((prev) => {
            const isAlreadySelected = prev.find((p) => p?.productNumber === item?.productNumber);
            if (isAlreadySelected) {
                return prev.filter((p) => p?.productNumber !== item?.productNumber); // Unselect
            } else {
                return [...prev, item]; // Select
            }
        });
    };

    useEffect(() => {
        if (data?.partList?.length > 0) {
            handleSelectAll(data?.partList, true)
        }
    }, [data?.partList])


    // Price x quantity for the selected parts, plus 18% GST
    const { subTotal, gst, grandTotal } = computeGstTotals(selectedProducts);


    const handleSaveSelection = async () => {
        const order = {
            total: Number(grandTotal.toFixed(2)),
            partList: selectedProducts,
            projectName: data?.projectName,
            application: data?.application,
            anualVolume: data?.anualVolume,
            endCustomer: data?.endCustomer,
            enquiryType: data?.enquiryType,
            orderType: from == "BOM" ? "BOM" : from == "Wizard" ? "WIZARD" : "EXCESS",
            sop: data?.sop,
            shippingAddress: selectedAddress,
            enquiryId
        }

        try {
            const response = await api.createPoOrder(order)
            if (response.data) {
                toast.success('Order created succefully')
                navigate('/userEnquires')
            }
        } catch (err) {
            console.log(err);
            toast.error(err?.response?.data?.message || 'something went wrong')
        }
        finally {
            setOpen(false)
        }
        // dispatch(setSelectedProducts(selectedProducts));
    };

    const handleSelectAll = useCallback((products, checked) => {
        if (checked) {
            setSelectedProductsState(products)
        } else {
            setSelectedProductsState([])
        }
    }, [data?.partList]);


    const statusLabel = { NEW: 'Pending', QUOTED: 'Quoted', COMPLETED: 'Completed' }[data?.status] || data?.status || '-'
    const statusClass = { NEW: styles.edBadgePending, QUOTED: styles.edBadgeQuoted, COMPLETED: styles.edBadgeDone }[data?.status] || styles.edBadgePending
    const typeLabel = from == "BOM" ? "BOM" : from == "Wizard" ? "Wizard" : "Excess Inventory"
    const isQuoted = data?.status == 'QUOTED'
    const allSelected = data?.partList?.length > 0 && selectedProducts?.length === data?.partList?.length

    return (
        <div className={`${styles.profilebodyContainer} ${styles.edPage}`}>
            {/* Header */}
            <div className={styles.edHeader}>
                <div>
                    <div className={styles.edTitleRow}>
                        <h2 className={styles.edTitle}>Enquiry #{data?.enquiryId}</h2>
                        <span className={styles.edTypeBadge}>{typeLabel}</span>
                    </div>
                    <div className={styles.edMeta}>
                        <span>{formateDate(data?.createdAt)}</span>
                        {data?.user?.fullName && (
                            <>
                                <span className={styles.edDot}>•</span>
                                <span>Created by {data.user.fullName}</span>
                            </>
                        )}
                    </div>
                </div>
                <button className={styles.edBackBtn} onClick={() => navigate(-1)}>Back to List</button>
            </div>

            {/* Summary */}
            <div className={styles.edSummary}>
                <div className={styles.edStats}>
                    <div className={styles.edStat}>
                        <span className={styles.edStatLabel}>Enquiry #</span>
                        <span className={styles.edStatValue}>{data?.enquiryId}</span>
                    </div>
                    <div className={styles.edStat}>
                        <span className={styles.edStatLabel}>Status</span>
                        <span className={`${styles.edBadge} ${statusClass}`}>{statusLabel}</span>
                    </div>
                    <div className={styles.edStat}>
                        <span className={styles.edStatLabel}>Parts</span>
                        <span className={styles.edStatValue}>{data?.partList?.length || 0}</span>
                    </div>
                    {isQuoted && (
                        <div className={styles.edStat}>
                            <span className={styles.edStatLabel}>Grand Total</span>
                            <span className={styles.edStatValue}>{formatINR(grandTotal)}</span>
                        </div>
                    )}
                </div>
                <div>
                    {data?.status == 'NEW' ?
                        <span className={styles.edAwaiting}>Awaiting quote from Electrowiz</span>
                        :
                        data?.status == 'COMPLETED' ? null :
                            <button
                                className={styles.edPrimaryBtn}
                                disabled={selectedProducts?.length <= 0}
                                onClick={() => setOpen(true)}
                            >
                                Accept &amp; Create Order{selectedProducts?.length > 0 ? ` (${selectedProducts.length} item${selectedProducts.length > 1 ? 's' : ''})` : ''}
                            </button>
                    }
                </div>
            </div>

            {/* Parts */}
            <div className={styles.edTableCard}>
                <div className={styles.edTableTop}>
                    <span className={styles.edSectionTitle}>Part list</span>
                    {isQuoted && (
                        <label className={styles.edSelectAll}>
                            <input
                                type="checkbox"
                                checked={allSelected}
                                onChange={(e) => handleSelectAll(data?.partList, e.target.checked)}
                            />
                            Select all <span className={styles.edSelectCount}>{selectedProducts?.length} selected</span>
                        </label>
                    )}
                </div>
                <div className={styles.edTableScroll}>
                    <table className={styles.edTable}>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Part number</th>
                                <th>Manufacturer</th>
                                <th>Quantity</th>
                                {isQuoted && (
                                    <>
                                        <th>Price</th>
                                        <th>MOQ</th>
                                    </>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {data?.partList?.map((item, index) => (
                                <tr key={item.productNumber}>
                                    <td>
                                        <span className={styles.edIndexCell}>
                                            {isQuoted &&
                                                <input
                                                    type="checkbox"
                                                    checked={selectedProducts?.some((p) => p.productNumber === item.productNumber)}
                                                    onChange={() => handleCheckboxChange(item)}
                                                />
                                            }
                                            {index + 1}
                                        </span>
                                    </td>
                                    <td className={styles.edPart}>{item.productNumber}</td>
                                    <td>{item.manufacturer || '-'}</td>
                                    <td>{item.quantity}</td>
                                    {isQuoted && (
                                        <>
                                            <td>{item?.quotePrice ? `₹${item.quotePrice}` : '-'}</td>
                                            <td>{item.moq || '-'}</td>
                                        </>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {isQuoted && (
                <div className={styles.edTotals}>
                    <div className={styles.edTotalRow}>
                        <span>Sub Total ({selectedProducts?.length} item)</span>
                        <span>{formatINR(subTotal)}</span>
                    </div>
                    <div className={styles.edTotalRow}>
                        <span>Tax (18%)</span>
                        <span>{formatINR(gst)}</span>
                    </div>
                    <div className={`${styles.edTotalRow} ${styles.edGrandTotal}`}>
                        <span>Grand Total</span>
                        <span>{formatINR(grandTotal)}</span>
                    </div>
                </div>
            )}
            <DeliveryAddressPopup
                selectedAddress={selectedAddress}
                setSelectedAddress={setSelectedAddress}
                setOpen={setOpen}
                open={open}
                handleSubmit={handleSaveSelection}
            />
        </div>
    )
}

export default EnquiryDeets